import React from 'react';
import { FilterChangeHandler, FilterToolbar } from '@/components/filter-toolbar';
import { parseAsArrayOf, parseAsString, useQueryStates } from 'nuqs';
import { KBType } from '@/modules/gpt-chats/models/kb';
import { useTranslation } from 'react-i18next';

export const useKBFilterQueryParams = () => {
  const [queryParams, setQueryParams] = useQueryStates({
    fileTypes: parseAsArrayOf(parseAsString).withDefault([]),
    createStartDate: parseAsString.withDefault(''),
    createEndDate: parseAsString.withDefault(''),
  });
  return { queryParams, setQueryParams };
};

interface KBDocumentsTableToolbarProps {
  activeTab: KBType;
}

export function KBDocumentsTableToolbar({ activeTab }: KBDocumentsTableToolbarProps) {
  const { t } = useTranslation();
  const { queryParams, setQueryParams } = useKBFilterQueryParams();

  const onChange: FilterChangeHandler<{
    fileTypes: string[];
    createDate: { from?: Date; to?: Date } | null;
  }> = (key, value) => {
    if (key === 'createDate') {
      const { from, to } = value as { from?: Date; to?: Date };

      return setQueryParams((prev) => ({
        ...prev,
        createStartDate: from?.toISOString() || '',
        createEndDate: to?.toISOString() || '',
      }));
    }
    setQueryParams((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const onReset = () => {
    setQueryParams(null);
  };

  const filters: any[] = [
    {
      key: 'createDate',
      type: 'DateRange',
      label: t('CREATE_DATE'),
      props: {},
    },
  ];

  if (activeTab === KBType.FILE) {
    filters.unshift({
      key: 'fileTypes',
      type: 'MultiSelect',
      label: t('FILE_TYPE'),
      props: {
        options: [
          { label: t('PDF'), value: 'pdf' },
          { label: t('TXT'), value: 'txt' },
        ],
      },
    });
  }

  return (
    <FilterToolbar
      filters={filters}
      values={{
        fileTypes: queryParams.fileTypes,
        createDate: {
          from: queryParams.createStartDate ? new Date(queryParams.createStartDate) : undefined,
          to: queryParams.createEndDate ? new Date(queryParams.createEndDate) : undefined,
        },
      }}
      defaultValues={{ fileTypes: [], createDate: { from: undefined, to: undefined } }}
      onChange={onChange}
      onReset={onReset}
    />
  );
}
